import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../../../components/panel/panel';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import * as formik from 'formik';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import axiosClient from '../../../../config/axios.js';
import VehicleModelFields from './vehicleModelFields.js';


function NewVehicleModel() {
    const navigate = useNavigate();
    const { Formik } = formik;
    

    return (
        <div>
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Inicio</Link></li>
                        <li className="breadcrumb-item">Configuración</li>
                        <li className="breadcrumb-item"><Link to="/catalogs/marcas">Modelo de Vehículos</Link></li>
                        <li className="breadcrumb-item active">Nuevo Modelo de Vehículo</li>
                    </ol>
                    <h1 className="page-header mb-0">Registro de nuevo Modelo de Vehículo</h1>
                </div>
            </div>



            <div className="row mb-3">
                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>Registro de nuevo Modelo de Vehículo</PanelHeader>
                        <PanelBody>
                            <Formik
                                validationSchema={yup.object().shape({
                                    vehicle_type_id: yup.number().required("Seleccione el tipo de vehículo"),
                                    brand_id: yup.number().required("Seleccione la marca del vehículo"),
                                    model_name: yup.string().required("Ingrese el nombre del Modelo de Vehículo"),
                                })}
                                onSubmit={(values, { setSubmitting }) => {
                                    setSubmitting(false);
                                    axiosClient.post('/vehicleModels/save', values).then(response => {
                                        Swal.fire({
                                            title: 'Registro exitoso.',
                                            text: 'Se ha registrado el nuevo Modelo de Vehículo',
                                            icon: 'success',
                                            confirmButtonText: 'Cerrar',
                                            cancelButtonText: 'Cancelar',
                                            showCancelButton: false,
                                        });
                                        navigate('/catalogs/brandsModels');
                                    }).catch(err => {
                                       // console.log(err);
                                      
                                        let message = err.response.data.message;
                                      
                                        Swal.fire({
                                            title: 'Ups!',
                                            text: message,
                                            icon: 'error',
                                            confirmButtonText: 'Cerrar',
                                            cancelButtonText: 'Cancelar',
                                            showCancelButton: false,
                                        });
                                    });
                                }}
                                initialValues={{
                                    model_name: ''
                                }}
                            >
                                {({ handleSubmit, handleChange, values, setFieldValue, errors, touched }) => (
                                    <Form noValidate onSubmit={handleSubmit}>


                                        <VehicleModelFields
                                            values={values}
                                            handleChange={handleChange}
                                            touched={touched}
                                            errors={errors}
                                            setFieldValue={setFieldValue}
                                        />

                                        <Row className="mb-3">
                                            <Col md="12">
                                                <Button type="submit">Guardar Modelo de Vehículo</Button>{' '}
                                                <Link to={'/catalogs/brandsModels'} className="btn btn-info">Cancelar</Link>
                                            </Col>
                                        </Row>
                                    </Form>
                                )}
                            </Formik>

                        </PanelBody>
                    </Panel>
                </div>

            </div>


        </div>

    );
}

export default NewVehicleModel;